import React, { useState, useEffect } from "react";
import axios from "axios";
import { Radio, Table, Input, DatePicker, Modal, Button, Menu, Col, Row, message, Space } from "antd";
import { Link, useParams, useNavigate } from "react-router-dom";
import { InboxOutlined, PlusOutlined, EditOutlined, ExclamationCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import AdminGradeModal from "./components/AdminGradeModal";
import './css/TableTitle.css'
import NewTable from "./components/NewTable";
const { RangePicker } = DatePicker;
const GradeList = () => {
    const [total, set_total] = useState(1);
    const [extra_columns, set_extra_columns] = useState(null);
    const [search_date, set_search_date] = useState([])
    const [loading, set_loading] = useState(0)
    const [force_reload, set_force_reload] = useState(0)
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [title, setTitle] = useState();
    const [edit, setEdit] = useState(false);
    const [open, setOpen] = useState(false);
    const [editcard, setEditCard] = useState({});
    const [color, setColor] = useState('d65b77');
    const { confirm } = Modal;
    const [msg, setMsg] = useState(0);
    const [messageApi, contextHolder] = message.useMessage();
    const [datas, setDatas] = useState([{
    }])
    const showMessage = (value) => {
        confirm({
            title: '確定要刪除嗎',
            icon: <ExclamationCircleOutlined />,
            okText: '確定',
            okType: 'primary',
            cancelText: '取消',
            onOk() {
                handleOnDelete(value);
            },
            centered: true
        });
    };
    const rowSelection = {
        selectedRowKeys: selectedRowKeys,
        onSelectAll: (selected, selectedRows, changeRows) => {
            if (selectedRowKeys.length !== 0) {
                setSelectedRowKeys([]);
            }
        },
        onChange: (selectedRowKeys, selectedRows) => {
            setSelectedRowKeys(selectedRowKeys);

        },

    };
    const get_datas = (param, sort, filter, checklist) => {
        set_loading(true);
        axios
            .get(`/cramSchool/api/grade`, {
                params: {
                    cur_page: param?.current,
                    size: param?.pageSize,
                    custom_filter_key: checklist,
                    custom_filter_value: param?.keyword,
                    order: sort && Object.entries(sort).map(([map_key, map_value]) => ({ column: map_key, type: map_value }))
                }
            })
            .then((response) => {
                set_total(response.data.total)
                setDatas(response.data.data);
            })
            .finally(() => {
                set_loading(false)
            })
    }
    const handleOnDelete = (value) => {
        axios
            .delete(`/cramSchool/api/grade`, {
                data: [{ grade_id: value }]
            })
            .then((response) => {
                // console.log(response)
                if (response.data.status == 'success') {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '刪除成功',
                    });
                    get_datas();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '刪除失敗',
                    });
                    get_datas();
                }
            })
    }
    const handleOnDeleteAll = () => {
        if (selectedRowKeys.length == 0) {
            messageApi.open({
                type: 'error',
                content: '請選擇資料',
            });
        } else {
            const deleterow = [];
            selectedRowKeys && selectedRowKeys.map((value, i) => {
                deleterow.push({ 'grade_id': value })
            })
            axios
                .delete(`/cramSchool/api/grade`, {
                    data: deleterow
                })
                .then((response) => {
                    // console.log(response)
                    if (response.data.status == 'success') {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: '刪除成功',
                        });
                        reload();
                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: '刪除失敗',
                        });
                        reload();
                    }
                })
        }
    }
    const reload = () => {
        set_force_reload(prev => prev + 1)
    }
    useEffect(() => {
        get_datas()
    }, []);
    const handleEdit = () => {
        axios
            .patch(`/cramSchool/api/grade`, [editcard])
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '修改失敗',
                    });
                    reload();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '修改成功',
                    });
                    reload();
                }
            })
    }
    const handleOnAddRow = () => {
        setTitle('新增年級'); setColor('d65b77'); setEdit(false); setOpen(true); setEditCard({})
    }
    const handleSubmit = () => {
        if (JSON.stringify(editcard) == '{}') {
            // setOpen(false);
            messageApi.open({
                type: 'error',
                content: '新增失敗，請填寫任一欄位',
            });
        } else {
            axios
                .post(`/cramSchool/api/grade`, [editcard])
                .then((response) => {
                    if (response.data.status == 'failure') {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: '新增失敗',
                        });
                        reload();
                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: '新增成功',
                        });
                        reload();
                    }
                })
        }
    }
    return (
        <>
            {contextHolder}
            <AdminGradeModal
                open={open}
                edit={edit}
                title={title}
                color={color}
                editcard={editcard}
                setEditCard={setEditCard}
                setOpen={setOpen}
                handleSubmit={handleSubmit}
                handleEdit={handleEdit}
            />
            <Row style={{ paddingTop: '10px', paddingBottom: '10px' }}>
            </Row>
            <Row></Row>
            <NewTable
                total={total}
                extra_columns={extra_columns}
                set_extra_columns={set_extra_columns}
                loading={loading}
                page_name={'GradeList'}
                force_reload={force_reload}
                datas={datas}//table資料
                rowkey={'id'}//key
                getData={get_datas}
                columns={[
                    {
                        title: '編號',
                        key: 'serial_num',
                        dataIndex: 'serial_num'
                    },
                    {
                        title: '名稱',
                        key: 'name',
                        dataIndex: 'name',
                        sorter: false
                    },
                    {
                        title: '操作',
                        sorter: false,
                        align: 'center',
                        render: (text, record, index) => (
                            <>
                                {/* <button type="button" className="btn btn-link text-success" onClick={e => handleOnShow(record)}>修改</button>
                                    <button type="button" className="btn btn-link text-success" onClick={e => handleOnDelete(record.Pid)}>刪除</button> */}
                                <Button type="text" style={{ color: 'rgba(43, 193, 123, 1)' }} onClick={e => { setTitle('修改年級'); setColor('f09a45'); setEdit(true); setOpen(true); setEditCard(record) }}>編輯</Button>
                                <Button danger type="text" onClick={() => showMessage(record.grade_id)}>刪除</Button>
                            </>
                        )

                    },
                    // {
                    //     title: '',
                    //     render: (text, record, index) => <button type="button" className="btn btn-link text-success" onClick={e => handleOnDelete(record.Pid)}>刪除</button>
                    // }
                ].concat(extra_columns || [])}
                add_button_title={'新增年級'}//新增按鈕上的名稱
                handleOnAddRow={handleOnAddRow}//新增row 內容
                setSelectedRowKeys={setSelectedRowKeys}
                selectedRowKeys={selectedRowKeys}
                handleOnDeleteRow={handleOnDeleteAll}//多筆刪除
                scroll={{ x: 'max-content' }}
                tableLayout='fixed'
                rowSelection={{
                    ...rowSelection,
                }}
            />

        </>

    );
};
export default GradeList;
